export enum OutletOpeningHoursDateOfWeek {
  MONDAY='Monday',
  TUESDAY='Tuesday',
  WEDNESDAY='Wednesday',
  THURSDAY='Thursday',
  FRIDAY='Friday',
  SATURDAY='Saturday',
  SUNDAY='Sunday'
}